import { useQuery } from '@/hooks/useQuery';
import { api } from '@/services/api';
import type { SymbolInfo } from '@/types';

export function useSymbols(): { symbols: SymbolInfo[]; loading: boolean; error: string | null } {
  const { data, loading, error } = useQuery(() => api.symbols(), []);
  return { symbols: data?.symbols ?? [], loading, error };
}
